module.exports = __webpack_public_path__ + "media/images/emblems/Medel_Lucmagn_wappen-22bc97d9196b4c2dced7b65f1429021e.svg";